import type { ConvertableUnit } from "@/libs/units";
import { buildOptions } from "./buildOptions";

export const VoltAmps: ConvertableUnit = {
  label: "VA",
  toStandardUnit: VA => VA,
  toThisUnit: VA => VA
};

export const KiloVoltAmps: ConvertableUnit = {
  label: "kVA",
  toStandardUnit: kVA => kVA * 1000,
  toThisUnit: VA => VA / 1000
};

const unitList = [VoltAmps, KiloVoltAmps];
export const ApparentPowerUnits = {
  VoltAmps,
  KiloVoltAmps,
  options: buildOptions(unitList)
};
